// Email Preferences
export const REQUEST_EMAIL_PREFERENCES = 'REQUEST_EMAIL_PREFERENCES';
export const REQUEST_EMAIL_PREFERENCES_SUCCESS = 'REQUEST_EMAIL_PREFERENCES_SUCCESS';
export const REQUEST_EMAIL_PREFERENCES_FAIL = 'REQUEST_EMAIL_PREFERENCES_FAIL';
export const UPDATE_EMAIL_PREPREFERENCES = 'UPDATE_EMAIL_PREPREFERENCES';
export const UPDATE_EMAIL_PREPREFERENCES_FAIL = 'UPDATE_EMAIL_PREPREFERENCES_FAIL';
